import React, {useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {FaTrashCan} from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {BiShow, BiSolidEdit} from "react-icons/bi";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {LoadingSpinner} from "../LoadingSpinner";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {FiFilter} from "react-icons/fi";
import OpsToast from "../../ops-library/ops-toast";
import formatDate from "../../functions/formatDate";
import {FaPlus} from "react-icons/fa";
import formatTime from "../../functions/formatTime";
import {formatDateTime} from "../../functions/formatDateTime";
import OpsTable from "../../ops-library/ops-table";
import OpsIconStatus from "../../ops-library/ops-icon-status";
import {TbRestore} from "react-icons/tb";
import {IoIosTimer} from "react-icons/io";

const AdminConcerts = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [concerts, setConcerts] = useState(null)
    const [showAll, setShowAll] = useState(false)
    const [showDeleted, setShowDeleted] = useState(false)
    const [modalConcertShown, setModalConcertShown] = useState(false);
    const [loading, setLoading] = useState(true)

    const [modalData, setModalData] = useState(null);

    useEffect(() => {
        getConcerts();
    }, []);

    // API functions - get/patch/restore
    // ------------------------------------------------------------------------------
    function getConcerts(showDeleted = false, showAll = false) {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/concerts?includeDeleted=${showDeleted}&fromPast=${showAll}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios(configuration)
            .then((result) => {
                setConcerts(result.data.content)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    function patchConcert(id, data) {
        setLoading(true)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/concerts/${id}?includeDeleted=${showDeleted}&fromPast=${showAll}`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setConcerts(result.data.content)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    function restoreConcert(id) {
        setLoading(true)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/concerts/restore/${id}?includeDeleted=${showDeleted}&fromPast=${showAll}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setConcerts(result.data.content)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    // MODALS
    // ------------------------------------------------------------------------------
    function handleOpenModalConcert(data) {
        if (data) {
            setModalConcertShown(true);
            setModalData(data);
        } else {
            setModalConcertShown(true);
            setModalData(null);
        }
    }

    function handleModalsClose() {
        setModalConcertShown(false)
        setModalData(null)
    }

    const ModalConcert = ({show = false, onHide}) => {

        const [processed, setProcessed] = useState(false)
        const [date, setDate] = useState(formatDate(modalData?.dateTime ?? "", true, false, '-'))
        const [time, setTime] = useState(formatTime(modalData?.dateTime ?? "", false))
        const [city, setCity] = useState(modalData?.city ?? "")
        const [description, setDescription] = useState(modalData?.description ?? "")
        const [privated, setPrivated] = useState(modalData?.private ?? false)
        const [posterImg, setPosterImg] = useState(modalData?.posterImg ?? null)
        const [preview, setPreview] = useState(modalData?.posterImg ? `${process.env.REACT_APP_API_BASE_URL}/${modalData.posterImg}` : "");

        const [ticketsUrl, setTicketsUrl] = useState(modalData?.ticketsUrl ?? "")
        const [price, setPrice] = useState(modalData?.price ?? "")
        const [notes, setNotes] = useState(modalData?.notes ?? "")
        const [contact, setContact] = useState(modalData?.contact ?? "")

        // API functions - patch/post/delete
        // ------------------------------------------------------------------------------
        function patchConcert(id, data) {
            setProcessed(true)
            const formData = new FormData();
            formData.append("dateTime", data.dateTime);
            formData.append("city", data.city);
            formData.append("description", data.description);
            formData.append("privated", data.privated);
            formData.append("ticketsUrl", data.ticketsUrl);
            formData.append("price", data.price);
            formData.append("notes", data.notes);
            formData.append("contact", data.contact);
            if (data.posterImg) {
                formData.append("posterImg", data.posterImg);
            }

            const configuration = {
                method: "patch",
                url: `${process.env.REACT_APP_API_BASE_URL}/concerts/${id}?includeDeleted=${showDeleted}&fromPast=${showAll}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            };
            axios(configuration)
                .then((result) => {
                    if (result.data.content !== undefined) {
                        setConcerts(result.data.content)
                        OpsToast(result.data.message, "success")
                        handleModalsClose()
                    }
                })
                .catch((error) => {
                    opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function postConcert(data) {
            setProcessed(true)

            const formData = new FormData();
            formData.append("dateTime", data.dateTime);
            formData.append("city", data.city);
            formData.append("description", data.description);
            formData.append("privated", data.privated);
            formData.append("ticketsUrl", data.ticketsUrl);
            formData.append("price", data.price);
            formData.append("notes", data.notes);
            formData.append("contact", data.contact);
            if (data.posterImg) {
                formData.append("posterImg", data.posterImg);
            }

            const configuration = {
                method: 'post',
                url: `${process.env.REACT_APP_API_BASE_URL}/concerts?includeDeleted=${showDeleted}&fromPast=${showAll}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setConcerts(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function deleteConcert(id) {
            setProcessed(true)
            const configuration = {
                method: 'delete',
                url: `${process.env.REACT_APP_API_BASE_URL}/concerts/${id}?includeDeleted=${showDeleted}&fromPast=${showAll}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setConcerts(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                setPosterImg(file);
                setPreview(URL.createObjectURL(file));
            }
        };

        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white"
                              className="modal-background-color">
                    <div className="fa-flex-row justify-content-between w-100 h-100">
                        <OpsText type="title" weight={700} color="primary-3" alignment="left"
                                 content={`${city}`}/>
                        <div className="fa-flex-row gap-2">
                            <OpsInput customType="switch" checked={privated}
                                      label="súkromná akcia"
                                      labelColor="color-1"
                                      onChange={() => setPrivated(!privated)}
                            />
                            {hasRoleAccess(sectionId, user.role) && <OpsBtn
                                icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                                variant="icon me-2"
                                padding={false}
                                action={() => {
                                    const actual_concert = modalData;
                                    handleModalsClose()
                                    opsConfirmDialog(
                                        "Vymazanie koncertu",
                                        `Naozaj si prajete odstrániť koncert?`,
                                        theme,
                                        () => deleteConcert(actual_concert._id),
                                        () => handleOpenModalConcert(actual_concert)
                                    )
                                }}
                            />}
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    {!processed ?
                        <div className="custom-modal-content justify-content-between">
                            <div className="fa-flex-col align-items-center gap-2 mt-2">
                                <div className="fa-flex-col align-items-center setting-col gap-4">
                                    {/*ZAKLADNE INFORMACIE*/}
                                    <div className="fa-flex-col fa-w-100">
                                        <OpsText type="subtitle" color="primary-3 fa-w-100" weight={600}
                                                 alignment="left"
                                                 content="Základné informácie (zverejnené)"/>
                                        <div className="desktop-row-phone-col gap-5">
                                            <OpsInput id="concert-date"
                                                      className="fa-w-100" componentClassName="fa-w-100"
                                                      label="Dátum"
                                                      type="date"
                                                      value={date} onChange={(e) => {
                                                setDate(e.target.value)
                                            }}
                                            />
                                            <OpsInput id="concert-time"
                                                      className="fa-w-100" componentClassName="fa-w-100"
                                                      label="Čas"
                                                      type="time"
                                                      value={time} onChange={(e) => {
                                                setTime(e.target.value)
                                            }}
                                            />
                                        </div>
                                        <OpsInput id="concert-city"
                                                  className="fa-w-100" componentClassName="fa-w-100"
                                                  label="Mesto"
                                                  value={city} onChange={(e) => {
                                            setCity(e.target.value)
                                        }}
                                        />
                                        <OpsInput id="concert-description"
                                                  className="fa-w-100" componentClassName="fa-w-100"
                                                  label="Krátky popis"
                                                  value={description} onChange={(e) => {
                                            setDescription(e.target.value)
                                        }}
                                        />
                                    </div>
                                    {/*DOPLNUJUCE INFORMACIE*/}
                                    <div className="fa-flex-col fa-w-100">
                                        <OpsText type="subtitle" color="primary-3 fa-w-100" weight={600}
                                                 alignment="left"
                                                 content="Doplňujúce informácie (neverejné)"/>
                                        <OpsInput id="concert-contact"
                                                  className="fa-w-100" componentClassName="fa-w-100"
                                                  label="Kontakt"
                                                  value={contact} onChange={(e) => {
                                            setContact(e.target.value)
                                        }}
                                        />
                                        <OpsInput id="concert-notes" customType="textarea"
                                                  className="fa-w-100" componentClassName="fa-w-100"
                                                  label="Poznámky"
                                                  value={notes} onChange={(e) => {
                                            setNotes(e.target.value)
                                        }}
                                        />
                                    </div>
                                    {/*PLAGAT A LISTKY*/}
                                    <div className="fa-flex-col fa-w-100">
                                        <OpsText type="subtitle" color="primary-3 fa-w-100" weight={600}
                                                 alignment="left"
                                                 content="Plagát a lístky"/>
                                        <OpsInput id="concert-tickets"
                                                  className="fa-w-100" componentClassName="fa-w-100"
                                                  label="Lístky (URL)"
                                                  placeholder="napr. https://www.ticketlive.sk/sk/event..."
                                                  maxLength={10000}
                                                  value={ticketsUrl} onChange={(e) => {
                                            setTicketsUrl(e.target.value)
                                        }}
                                        />
                                        <OpsInput
                                            id="coverImage"
                                            label="Plagát"
                                            customType="imgUpload"
                                            componentClassName="fa-w-100"
                                            size="bg"
                                            value={preview}
                                            onChange={handleFileChange}
                                        />

                                        {preview && <div className="fa-flex-col align-items-center mt-4">
                                            <img src={preview} className="fa-w-40" alt=""/>
                                        </div>}


                                    </div>
                                </div>
                            </div>

                            {hasRoleAccess(sectionId, user.role) &&
                                <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                                    <OpsBtn
                                        text="Zahodiť"
                                        variant="secondary"
                                        size="md mt-2"
                                        action={() => handleModalsClose()}
                                    />
                                    <OpsBtn
                                        text="Uložiť"
                                        variant="primary"
                                        size="md mt-2"
                                        action={() => modalData !== null ? patchConcert(modalData?._id,
                                            {
                                                dateTime: formatDateTime(date, time),
                                                city: city,
                                                description: description,
                                                privated: privated,
                                                posterImg: posterImg,
                                                ticketsUrl: ticketsUrl,
                                                price: price,
                                                notes: notes,
                                                contact: contact,
                                            }
                                        ) : postConcert(
                                            {
                                                dateTime: formatDateTime(date, time),
                                                city: city,
                                                description: description,
                                                privated: privated,
                                                posterImg: posterImg,
                                                ticketsUrl: ticketsUrl,
                                                price: price,
                                                notes: notes,
                                                contact: contact,
                                            }
                                        )
                                        }
                                    />
                                </div>
                            }

                        </div>
                        :
                        <div className="custom-modal-content">
                            <LoadingSpinner/>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <ModalConcert show={modalConcertShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="KONCERTY"/>

            {/* SPRAVA KONCERTOV */}
            <div className="adm-container fa-flex-col">
                <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                    <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                             content="Správa koncertov"/>
                    <div className="fa-flex-row">
                        {/*VYTVORIT KONCERT<*/}
                        {hasRoleAccess(sectionId, user.role) && <OpsBtn
                            id="tbl-create"
                            tooltipText="Pridať koncert"
                            icon={<FaPlus color="var(--color-p-300)"
                                          className="ops-icon-sm m-1 mx-3"/>}
                            variant="icon mx-1"
                            backgroundColor="bg-3 border border-1"
                            padding={false}
                            action={() => {
                                handleOpenModalConcert()
                            }}
                        />}
                        {/*ZOBRAZIT VSETKY*/}
                        <OpsBtn
                            id="tbl-filter"
                            tooltipText="Zobraziť všetky koncerty"
                            icon={<IoIosTimer color={!showAll ? "var(--color-p-300)" : "var(--color-1)"}
                                              className="ops-icon-sm m-1"/>}
                            variant="icon mx-1"
                            backgroundColor={`${!showAll ? 'bg-3' : 'bg-primary-3'} border border-1`}
                            padding={false}
                            action={() => {
                                setShowAll(!showAll)
                                getConcerts(showDeleted, !showAll)
                            }}
                        />
                        {/*ZOBRAZIT AJ ZMAZANE*/}
                        <OpsBtn
                            id="tbl-filter-deleted"
                            tooltipText="Zobraziť zmazané koncerty"
                            icon={<FiFilter color={!showDeleted ? "var(--color-p-300)" : "var(--color-1)"}
                                            className="ops-icon-sm m-1"/>}
                            variant="icon mx-1"
                            backgroundColor={`${!showDeleted ? 'bg-3' : 'bg-primary-3'} border border-1`}
                            padding={false}
                            action={() => {
                                setShowDeleted(!showDeleted)
                                getConcerts(!showDeleted, showAll)
                            }}
                        />
                    </div>
                </div>
                {/*HLAVNA TABUĽKA*/}
                <OpsTable
                    id="concerts"
                    name=""
                    theme={theme}
                    classname=""
                    columns={[
                        {
                            name: "Dátum",
                            selector: row => new Date(row.dateTime).getTime(),
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${new Date(row.dateTime).toLocaleDateString('sk-SK', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }).replace(/\s/g, '')} - ${new Date(row.dateTime).toLocaleTimeString('sk-SK', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })}`}
                                />
                            )
                        },
                        {
                            name: "Mesto",
                            selector: row => row.city,
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.city}
                                />
                            )
                        },
                        {
                            name: "Popis",
                            selector: row => row.description,
                            sortable: false,
                            width: '20%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.description}
                                />
                            )
                        },
                        {
                            name: "Kontakt",
                            selector: row => row.contact,
                            sortable: false,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.contact}
                                />
                            )
                        },
                        {
                            name: "Poznámky",
                            selector: row => row.notes,
                            sortable: false,
                            width: '20%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.notes}
                                />
                            )
                        },
                        {
                            name: "",
                            selector: row => row.published,
                            sortable: false,
                            width: '8%',
                            cell: (row) =>
                                <div className="fa-flex-row gap-2 fa-w-100">
                                    <OpsIconStatus
                                        status={row.ticketsUrl.length > 0 ? 'ticket' : ''}/>
                                    <OpsIconStatus
                                        status={row.published === true ? 'completed' : ''}/>
                                </div>
                        },
                        {
                            name: "",
                            sortable: false,
                            selector: null,
                            width: '11%',
                            cell: (row) => [
                                !row.deleted && <OpsBtn
                                    key={0}
                                    icon={<BiSolidEdit className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={row.deleted ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => handleOpenModalConcert(row)}
                                />,
                                row.deleted && <OpsBtn
                                    key={1}
                                    icon={<TbRestore className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor="bg-g-2"
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Obnovenie koncertu",
                                            `Naozaj si prajete obnoviť koncert?`,
                                            theme,
                                            () => restoreConcert(row._id),
                                            () => null
                                        )
                                    }}
                                />,
                                hasRoleAccess(sectionId, user.role) && !row.deleted && <OpsBtn
                                    key={2}
                                    icon={<BiShow className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={!row.published ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Zverejnenie koncertu",
                                            `Naozaj si prajete ${row.published ? 'zrušiť uverejnenie koncertu' : 'uverejniť koncert'}?`,
                                            theme,
                                            () => patchConcert(row._id, {published: !row.published}),
                                            () => null
                                        )

                                    }}
                                />
                            ]
                        }
                    ]}
                    data={loading === false ? concerts : []}
                    functionEdit={handleOpenModalConcert}
                    functionPublish={patchConcert}
                    functionRestore={restoreConcert}
                />
            </div>
        </div>
    )
}

export default AdminConcerts;